import { BaseClient } from "../../clients/base/BaseClient";
import { DRIVERS_ENDPOINTS } from "./drivers.consts";
import type { DriversResponse } from "./drivers.types";

/**
 * Drivers API Client
 * Handles all driver-related API operations.
 */
export class DriversClient extends BaseClient {
  /**
   * Fetch all supported drivers.
   * @param {AbortSignal | null} signal - Optional abort signal for request cancellation.
   * @returns {Promise<DriversResponse>} Array of all supported drivers.
   */
  async fetchDrivers(signal?: AbortSignal | null): Promise<DriversResponse> {
    return this.get<DriversResponse>(DRIVERS_ENDPOINTS.DRIVERS, {
      signal,
    });
  }
}
